"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chain = exports.Methods = exports.DID = void 0;
const models_1 = require("./models");
Object.defineProperty(exports, "Methods", { enumerable: true, get: function () { return models_1.Methods; } });
Object.defineProperty(exports, "Chain", { enumerable: true, get: function () { return models_1.Chain; } });
/* eslint-disable no-underscore-dangle */
class DID {
    constructor() {
        /**
         * Mappings from methods to DIDs
         */
        this._dids = new Map();
    }
    /**
     * Gets a DID for a particular method
     *
     * @example
     * ```typescript
     * import { DID, Network } from '@ew-did-registry/did';
     *
     * const did = new DID();
     * did.set('bitcoin', 'method_specific_id');
     * console.log(did.get('bitcoin')); // 'did:bitcoin:method_specific_id'
     *
     * const did = new DID();
     * did.set(Methods.Erc1056, 'method_specific_id');
     * console.log(did.get(Methods.Erc1056)); // 'did:eth:method_specific_id'
     * ```
     *
     * @param { Methods } method
     *
     * @returns { string|undefined }
     */
    get(method) {
        return this._dids.get(method);
    }
    /**
     * Sets a DID for the provided method
     *
     * @example
     * ```typescript
     * import { DID } from '@ew-did-registry/did';
     *
     * const did = new DID();
     * did.set('eth', 'method_specific_id');
     * console.log(did.get('eth')); // 'did:eth:method_specific_id'
     * ```
     *
     * @param { Methods } method
     * @param {string} chain
     * @param {string} id
     *
     * @returns {void}
     */
    // eslint-disable-next-line no-dupe-class-members
    set(method, chain, id) {
        if (method.startsWith('did:')) {
            return this._setDid(method);
        }
        if (id !== undefined) {
            return this._setDid(`did:${method}:${chain}:${id}`);
        }
        return this._setDid(`did:${method}:${chain}`);
    }
    _setDid(did) {
        if (did.split(':').length > 3) {
            const [, method, chain, id] = did.split(':');
            if (id === undefined) {
                throw new Error('Identity cannot be undefined');
            }
            if (!models_1.DID_SCHEME_PATTERNS.NETWORK.test(`${method}:${chain}`)) {
                throw new Error('Network must not be empty and consist only of lowcase alphanumerical characters');
            }
            if (id !== undefined && !models_1.DID_SCHEME_PATTERNS.ID.test(id)) {
                throw new Error('Id must consist only of alphanumerical characters, dots, minuses and underscores');
            }
            this._dids.set(method, did);
            return this;
        }
        else {
            const [, method, id] = did.split(':');
            if (id === undefined) {
                throw new Error('DID must consist of three parts separated by a colon');
            }
            if (!models_1.DID_SCHEME_PATTERNS.NETWORK.test(method)) {
                throw new Error('Network must not be empty and consist only of lowcase alphanumerical characters');
            }
            if (!models_1.DID_SCHEME_PATTERNS.ID.test(id)) {
                throw new Error('Id must consist only of alphanumerical characters, dots, minuses and underscores');
            }
            this._dids.set(method, did);
            return this;
        }
    }
}
exports.DID = DID;
__exportStar(require("./utils/validation"), exports);
__exportStar(require("./utils/parser"), exports);
//# sourceMappingURL=index.js.map